import { rd, type RemoteData } from '@passionware/monads';
import { useTranslation } from 'react-i18next';
import type { SectionedChecklistSection } from 'v5/patterns/widgets/SectionedChecklist';
import type { ResourceFieldGroup } from './resourceFieldCatalog.logic';

/**
 * The resource field catalog as the field chooser's sections: each headed by its group and the
 * types that have it ("Social · People"). `label` names the catalog.
 */
export function useResourceFieldSections(
  catalog: RemoteData<ResourceFieldGroup[]>
): { sections: RemoteData<SectionedChecklistSection[]>; label: string } {
  const { t } = useTranslation('resource-fields', {
    keyPrefix: 'ResourceFieldSections'
  });
  return {
    label: t('label'),
    sections: rd.map(catalog, groups =>
      groups.map(group => ({
        id: `${group.id}:${group.onlyTypes?.join(',')}`,
        heading: [t(`groups.${group.id}`), group.onlyTypes?.join(', ')]
          .filter(Boolean)
          .join(' · '),
        items: group.options.map(option => ({
          id: option.key,
          label: option.label
        }))
      }))
    )
  };
}
